<template>
  <div id="scroll-board">
    <dv-scroll-board :config="config" @click="clickHandler"/>
    <a-modal v-model="visible" :centered="true" :title="address" okText="打印" @ok="handleOk">
      <vue-easy-print tableShow ref="easyPrint" >
        <template slot-scope="func">
          <print-details-info :detailsInfo="detailsInfo" :getChineseNumber="func.getChineseNumber" />
        </template>
      </vue-easy-print>
    </a-modal>
  </div>
</template>

<script>
  import vueEasyPrint from "vue-easy-print";
  import PrintDetailsInfo from './PrintDetailsInfo';

let config = {};

export default {
  name: 'ScrollBoard',
  props: {
    dateValue: {
      type: String,
      required: true
    }
  },
  components: {
    vueEasyPrint,
    PrintDetailsInfo
  },
  data () {
    return {
      config,
      visible: false,
      address: '',
      detailsInfos: [],
      detailsInfo: {}
    }
  },
  methods: {
    clickHandler(e){
      let address = e.row[1];
      this.detailsInfo = this.detailsInfos.find(function (item) {
        if(item.memberName === address){
          return item;
        }
      })
      // this.detailsInfo = this.detailsInfos[e.row[0]-1];
      this.detailsInfo.address = address;
      this.address = e.row[1];
      this.visible = true;
    },
    handleOk(e){
      this.$refs.easyPrint.print();
    },
    garbageClassify(){
      // 日期 统计时 使用
      this.$message.success(this.dateValue);
    },
    createData(){
      let streetId = localStorage.getItem("streetId")
      if (!streetId) {
        streetId = JSON.parse(localStorage.getItem("USER")).streetId;
      }
      let params = {streetId: streetId};
      this.$get('/data/showCategories',{
        ...params
      }).then((r)=>{
        let data = r.data;
        if(data.code != 200){
          this.$message.error("权限不足");
        } else {
          this.detailsInfos = data.data;
          let categories = [];
          let catItem;
          let participant = 0;
          let unqualified = 0;
          let qualified = 0;
          let empty = 0;
          let userCount = 0;
          let memberName = "";
          data.data.forEach(function (value,index) {
            catItem = new Array();
            unqualified = value.unqualified;
            qualified = value.qualified;
            empty = value.empty;

            participant = unqualified + qualified + empty;
            userCount = value.memNum;
            memberName = value.memberName;
            catItem.push(index+1);
            catItem.push(memberName);
            if(userCount != 0){
              let flag = value.flag;
              if(flag){
                userCount = userCount * 2;
              }
              catItem.push(Math.floor((participant/userCount)*10000)/100);
            }else{
              catItem.push(0);
            }
            if (participant != 0){
              catItem.push(Math.floor(((qualified+empty)/participant)*10000)/100);
            }else {
              catItem.push(0);
            }
            categories.push(catItem);
          });
          categories.sort(function (a,b){
            return b[2] - a[2];
          })
          let index = 1;
          let categoriess = [];
          categories.forEach(function (item){
            item[0] = index++;
            item[2] = item[2] + "%";
            item[3] = item[3] + "%";
            categoriess.push(item);
          })
          this.config = {
            header: ['名次', '地区', '综合参与率','正确率'],
            data: categoriess,
            align: ['center'],
            rowNum: 10,
            headerBGC: '#1981f6',
            headerHeight: 30,
            oddRowBGC: 'rgba(0, 44, 81, 0.8)',
            evenRowBGC: 'rgba(10, 29, 50, 0.8)',
            waitTime: 2500,
            hoverPause: false
          };
        }
      });
    }
  },
  watch: {
    dateValue: 'garbageClassify'
  },
  mounted() {
    const {createData} = this;
    createData();
    const timer = setInterval(createData, 100000);
    this.$once('hook:beforeDestroy',function () {
      clearInterval(timer);
    });
  }
}
</script>

<style lang="less">
#scroll-board {
  width: 100%;
  height: 80%;
  cursor: pointer;
}
.details-table{
  width: 85%;
}
.details-table .details-left{
  text-align: right;
  padding-right: 30px;
}
.details-table .details-right{
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/views/datav/scrollBoard.vue